//* Bdd models alike //

import dayjs, { Dayjs } from "dayjs";
import localeData from "dayjs/plugin/localeData";
dayjs.extend(localeData);

export type GqlAttendance = {
  StudentId: string;
  attendance?: string | null;
  createdAt: string;
  date?: string | null;
  id: string;
  observations?: string | null;
  rating?: string | null;
};

export type GqlHomework = {
  StudentId: string;
  createdAt: string;
  date?: string | null;
  done?: boolean | null;
  id: string;
  name?: string | null;
  none?: boolean | null;
  observations?: string | null;
  undone?: boolean | null;
};

export type GqlStudent = {
  Attendances?: Array<GqlAttendance | null> | null;
  ClassRoomId?: string | null;
  Homeworks?: Array<GqlHomework | null> | null;
  avatar?: string | null;
  averageAtttendance?: number | null;
  averageHomework?: number | null;
  averageRating?: number | null;
  createdAt?: string | null;
  date?: string | null;
  id: string;
  name: string;
  observations?: string | null;
};

export type GqlClassRoom = {
  Students?: Array<GqlStudent | null> | null;
  UserId: string;
  createdAt: string;
  endYear?: string | null;
  id: string;
  initYear?: string | null;
  name: string;
  observations?: string | null;
  shortName?: string | null;
  subject: string;
  year?: number | null;
};

//* Teacher User type
export type User = {
  id: Id;
  firstName: string;
  lastName: string;
  email: string;
  country: {
    code: string | null;
    name: string | null;
  };
  jobTitle: string | null;
  bio: string | null;
  subjects: string[];
  avatarUrl: {
    large: string | null;
    small: string | null;
  };
  isOnboarded: boolean;
};

export type StudentAttendance = {
  id: number;
  date: CustomDate;
  classRoom: classRoom; //? BE join table
  attendance: keyof typeof Attendance; //? BE join table
  rating: StudentRating;
  homeWork: HomeWork;
};

export type AttendanceById = {
  studentId: number;
  attendanceData: StudentAttendance[];
  averageAtttendance: number;
  averageRating: number;
  averageHomework: number;
  homeWorks: number;
};

//* Desire ClasRoom Type (For BE)
export type ClassRoom = {
  id: string;
  name: string;
  students: Student[]; //TODO: Add this to the BE
  year?: number;
  color?: string;
};

//* List of class view
export type Student = {
  id: string;
  name: string;
  createdAt: string;
  classRoom: classRoom; // BE join table
  attendance: Attendance;
  rating: StudentRating;
  homeWork: HomeWork;
  attendanceData?: StudentAttendance[]; // BE join table
  index: number;
  averageAtttendance?: number; //? average from attendanceData list. Percentage
  averageRating?: number; //? average from attendanceData list. Percentage
  averageHomework?: number; //? average from attendanceData list. Average not percentage. Ex: 2/10
  color?: string; //? Only for FE porposes
  photo?: string;
  avatar?: string;
};

export type classRoom = {
  id: number;
  studentId: number;
  classId: number;
  className: string;
};

/**
 * * App types
 */

export type YearAverageQualifications = {
  numberOfRatings: number;
  numberOfAttendances: number;
  numberOfHomeWorks: number;
  attendance: number;
  rating: number;
  homeworks: number;
  ratingAvg: number;
  attendanceAvg: number;
  homeWorksAvg: number;
};

export type StudentRating = 0 | 1 | 2 | 3 | 4 | 5 | 6;
export type Id = number | string;
export enum Attendance {
  P = "P",
  A = "A",
}

export enum HomeWork {
  DONE = "DONE",
  UNDONE = "UNDONE",
  NONE = "NONE",
}

export interface MonthData extends GqlAttendance {
  homeWork: GqlHomework;
}

export type CustomDate = Dayjs | Date;
export type DaysArray = Dayjs[];
export type DivClickEvent = React.MouseEvent<HTMLDivElement, MouseEvent>;
export type HtmlButtonEvent = React.MouseEvent<HTMLButtonElement, MouseEvent>;
const monthNames = dayjs.months?.() ?? [];
const weekDayNames = dayjs.weekdays?.() ?? [];
export type DateRequest = { startDate: CustomDate; endDate: CustomDate };
export type MonthNames = typeof monthNames;
export type MonthName = string;
export type Weeknames = typeof weekDayNames;
export type WeekName = string;
export type AttendanceMonthlyData = Record<MonthName, MonthData[]>;
export type AttendanceYearlyData = Record<
  number,
  Record<MonthName, MonthData[]>
>;
export enum Languages {
  DEUTSCH = "DEUTSCH",
  ENGLISH = "ENGLISH",
}
export type TranslationKeyObj = {
  id: string;
  defaultMessage: string;
  composedMessage?: (text?: string) => string | JSX.Element;
  composedHtmlMessage?: JSX.Element;
};
export type TranslationObject = Record<string, TranslationKeyObj>;
export type SchoolYears = {
  currentYear: string;
  lastYear: string;
};

export enum BrowserNames {
  CHROME = "Chrome",
  FIREFOX = "Firefox",
  SAFARI = "Safari",
  OPERA = "Opera",
  EDGE = "Edge",
  IE = "IE",
  UNKNOWN = "Unknown",
}
